import { useContext, useCallback, useState } from 'react';
import { AjaxContext, formatListData, AppContext } from 'commons-ui';
import _get from 'lodash/get';
import { useHistory, useLocation } from 'react-router-dom';

const getPayload = (): { useCase: string; expName: string } => {
	const location = useLocation();
	const useCase: string = _get(location, ['state', 'rowData', 'useCase']);
	const expName: string = _get(location, ['state', 'rowData', 'expName']);
	return { useCase, expName };
};

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { app } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { appName } = app;
	const listAllSegments = useCallback(async () => {
		const result = await postData({
			endpoint: '/marketing/dashboard/staticSegments/listStaticSegments',
			queryParams: {
				appName
			}
		});
		const data = _get(result, ['data', 'data'], []);
		const rowCount = _get(result, ['data', 'count'], 0);
		const listData = formatListData(data);
		return { rowCount, data: listData };
	}, []);

	const handleFormCancel = () => {
		history.goBack();
	};
	const payload = getPayload();
	const listVersionHistory = useCallback(async () => {
		const result = await postData({
			endpoint: '/marketing/dashboard/staticSegments/showVersionHistory',
			queryParams: {
				appName
			},
			body: { useCase: payload.useCase, expName: payload.expName }
		});
		const data = _get(result, ['data', 'data'], []);
		const rowCount = _get(result, ['data', 'count'], 0);
		const listData = formatListData(data);
		return { rowCount, data: listData };
	}, []);

	const uploadCsvCreate = useCallback(async (formData: any) => {
		return postData({
			endpoint: '/marketing/dashboard/staticSegments/createSegment',
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },
			queryParams: {
				appName
			}
		});
	}, []);

	const uploadCsvEdit = useCallback((formData: any) => {
		return postData({
			endpoint: '/marketing/dashboard/staticSegments/editSegment',
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },
			queryParams: {
				appName
			}
		});
	}, []);

	const deleteSegmentCall = useCallback(async (useCase: string, segName: string) => {
		const result = await postData({
			endpoint: '/marketing/dashboard/staticSegments/deleteSegment',
			body: { useCase, segName },
			queryParams: {
				appName
			}
		});
		return result;
	}, []);

	const deleteSegment = useCallback(async (rowData: any, showAlert: any) => {
		const { useCase, expName } = rowData;
		try {
			const response = await deleteSegmentCall(useCase, expName);
			if (response.status !== 200 || !response.data.success) {
				showAlert(response.error || 'Error occured while deleting segment', { type: 'error' });
				return;
			}
			showAlert('Segment deleted successfully');
		} catch (error: any) {
			showAlert(error.response.error || 'Error occured while deleting segment', { type: 'error' });
		}
	}, []);

	return {
		listAllSegments,
		showLoader,
		setShowLoader,
		handleFormCancel,
		listVersionHistory,
		uploadCsvCreate,
		uploadCsvEdit,
		deleteSegment
	};
};

export default useService;
